import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "onChange", "allowClear"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable import/order */
import React from 'react';
import PropTypes from 'prop-types';

// Lodash
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _values from 'lodash/values';
import _isEmpty from 'lodash/isEmpty';
import _compact from 'lodash/compact';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import PRESET_ID, { DEFAULT_DATE_RANGE_PRESETS } from './constants/dateRange.presetIds';

// Utils
import { toMoment } from '@tekion/tekion-base/utils/dateUtils';

// Components
import DateRange from './DateRange';

// Helpers
import getPresetList from './presetList';
import { getDateRangeValue } from './dateRange.helpers';
var DateRangeManager = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRangeManager, _React$Component);
  var _super = _createSuper(DateRangeManager);
  function DateRangeManager() {
    var _this;
    _classCallCheck(this, DateRangeManager);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      dateValues: null
    });
    _defineProperty(_assertThisInitialized(_this), "getDefaultDateValues", function () {
      var _this$props = _this.props,
        values = _this$props.values,
        defaultPreset = _this$props.defaultPreset;
      var defaultValues = _map(values, toMoment);
      return _isEmpty(defaultValues) ? getPresetList()[defaultPreset] : defaultValues;
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
      var onChange = _this.props.onChange;
      var dateRangeValue = getDateRangeValue(value);
      onChange(dateRangeValue);
    });
    return _this;
  }
  _createClass(DateRangeManager, [{
    key: "render",
    value: function render() {
      var dateValues = this.state.dateValues;
      var _this$props2 = this.props,
        className = _this$props2.className,
        onChange = _this$props2.onChange,
        allowClear = _this$props2.allowClear,
        restOfProps = _objectWithoutProperties(_this$props2, _excluded);
      var defaultValue = this.getDefaultDateValues();
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement(DateRange, _extends({}, restOfProps, {
        onChange: this.handleChange,
        allowClear: allowClear,
        getValueFromProps: true,
        values: dateValues,
        defaultValue: defaultValue
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.values !== state.dateValues) {
        return {
          dateValues: _isEmpty(_compact(props.values)) ? props.values : _map(props.values, toMoment)
        };
      }
      return null;
    }
  }]);
  return DateRangeManager;
}(React.Component);
DateRangeManager.propTypes = {
  onApply: PropTypes.func,
  onCancel: PropTypes.func,
  defaultPreset: PropTypes.string,
  presetId: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  defaultFallBack: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  allowClear: PropTypes.bool,
  values: PropTypes.array
};
DateRangeManager.defaultProps = {
  onApply: _noop,
  onCancel: _noop,
  defaultPreset: PRESET_ID.CUSTOM,
  defaultFallBack: PRESET_ID.CUSTOM,
  presetId: _values(DEFAULT_DATE_RANGE_PRESETS),
  className: '',
  allowClear: true,
  values: EMPTY_ARRAY
};
export default DateRangeManager;